module.exports = __webpack_public_path__ + "media/images/plans/img_small-ceremony-8c66e6be5900e51d836c47d445b3f770.jpg";